import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=0baf4be2&scoped=true"
import script from "./recipients.vue?vue&type=script&lang=js"
export * from "./recipients.vue?vue&type=script&lang=js"
import style0 from "./recipients.vue?vue&type=style&index=0&id=0baf4be2&prod&lang=less"
import style1 from "./recipients.vue?vue&type=style&index=1&id=0baf4be2&prod&lang=less"
import style2 from "./recipients.vue?vue&type=style&index=2&id=0baf4be2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf4be2",
  null
  
)

export default component.exports